import { StateCreator } from 'zustand'
import { InventoryItem } from '../types'

export interface InventorySlice {
  inventory: InventoryItem[]
  addInventoryItem: (item: InventoryItem) => void
  updateInventoryItem: (id: string, updatedItem: Partial<InventoryItem>) => void
  removeInventoryItem: (id: string) => void
  setInventory: (items: InventoryItem[]) => void
}

export const createInventorySlice: StateCreator<InventorySlice> = (set) => ({
  inventory: [],
  addInventoryItem: (item) =>
    set((state) => ({ inventory: [...state.inventory, item] })),
  updateInventoryItem: (id, updatedItem) =>
    set((state) => ({
      inventory: state.inventory.map((item) =>
        item.id === id ? { ...item, ...updatedItem } : item,
      ),
    })),
  removeInventoryItem: (id) =>
    set((state) => ({
      inventory: state.inventory.filter((item) => item.id !== id),
    })),
  setInventory: (items) => set({ inventory: items }),
})
